import { fg } from '@atlaskit/platform-feature-flags';

import {
	DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
} from '../../entities';
import { type TypeFilterValue3PEntities, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { SlackIcon } from './icon';
import { SlackIconBorderless } from './icon-borderless';
import { SlackSearchResultIcon } from './search-result-icon';

export const slackConfig: ThirdPartyConfig = {
	displayName: 'Slack',
	id: 'slack',
	resourceType: 'slack-connector',
	icon: get3PLogo(SlackIcon, 'Slack', 'medium'),
	iconBorderless: get3PLogo(SlackIconBorderless, 'Slack', 'small'),
	searchResultIcon: get3PLogo(SlackSearchResultIcon, 'Slack', 'large'),
	integrationAri: 'ari:cloud:platform::integration/slack',
	typeFilterConfig: (() => {
		const typeFilter = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

		// Always include Message
		typeFilter.set(TypeFilterValueKey.Message, {
			entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
			subTypes3P: [],
		});

		// Only include Conversation when:
		// - ai_3p_slack_federated_search_enabled is false, OR
		// - ai_3p_slack_federated_search_enabled is true AND slack_federated_search_channel_search_enabled is true
		if (
			!fg('ai_3p_slack_federated_search_enabled') ||
			fg('slack_federated_search_channel_search_enabled')
		) {
			typeFilter.set(TypeFilterValueKey.Conversation, {
				entities3P: DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
				subTypes3P: [],
			});
		}

		return typeFilter;
	})(),
	filters: ['lastUpdated'],
	requiresOauth: true,
	isEnabled: () => true,
};
